module.exports = __webpack_public_path__ + "static/img/aa-6.f4f8e27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-6.png
// module id = 15zt
// module chunks = 1